import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

const computeTimeFromISOString = (isoStringTime: string) => `${dayjs(isoStringTime).tz('America/Tijuana').format('HH:mm')}:00.000Z`;
/**
 *
 * @param firstPartOfISOstringDate Example: 2024-04-04
 * @param isoStringTime Example 2024-04-04T00:00:00.000Z
 */
export const computeParkingDate = (firstPartOfISOstringDate: string, isoStringTime: string) =>
  `${firstPartOfISOstringDate}T${computeTimeFromISOString(isoStringTime)}`;

export const computeFirstPartOfISOStringFromDayjs = (date: Dayjs) => date.toISOString().split('T')[0];
